








































































































































import Super from "@/pv4-super-class"
import { Component } from "vue-property-decorator"

import { find, capitalize, get } from "lodash"
import { Promise } from "bluebird"

import DueDateSelector from "@/components/selectors/DueDateSelector.vue"
import ModalHeader from "@/components/ModalHeader.vue"

@Component({ components: { DueDateSelector, ModalHeader } })
export default class TaskCreate extends Super {
  tasks: any = []
  saved = true
  task: any = {}
  accounts: any = {}
  taskStatus: any = 0
  taskDependencyID = 0

  setUnsaved() {
    this.saved = false
  }

  mounted() {
    this.load()
  }

  /**
   * Load Tasks and Accounts list from API
   */
  load() {
    const promises = {
      tasks: this.http.get(`/task?eventID=${this.eventId}`),
      accounts: this.http.get(`/account/all`)
    }

    Promise.props(promises)
      .then(res => {
        this.tasks = get(res, "tasks.data", null)
        this.accounts = get(res, "accounts.data", null)
      })
      .catch(this.displayError)
  }

  /**
   * Convert user.name to User Name- remove period and capitalise first and last name
   * @param samName
   */
  namify(samName: string) {
    const [firstname, lastname] = samName.split(".")
    return `${capitalize(firstname)} ${capitalize(lastname)}`
  }

  /**
   * Get an account based on userID
   * @param userID
   */
  getUser(userID: string | number) {
    return find(this.accounts, { userID })
  }

  /**
   * Get a task based on taskID
   * @param taskID
   */
  getTask(taskID: string | number) {
    return find(this.tasks, { taskID })
  }

  /**
   * Create new task, send to API
   */
  save() {
    const data = {
      ...this.task,
      taskStatus: this.taskStatus,
      eventID: this.eventId,
      taskAssignerID: this.account.userID,
      taskDependencyID: this.taskDependencyID
    }

    this.http
      .post(`/task?eventID=${this.eventId}`, data)
      .then(this.back)
      .catch(this.displayError)
  }

  /**
   * Return back, close modal
   */
  back() {
    this.$emit("close")
  }
}
